/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sleek_OutfitInputs */

const en_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleek (Outfit)`)
};

const es_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegante (Outfit)`)
};

const fr_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élégant (Outfit)`)
};

const de_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegant (Outfit)`)
};

const ja_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スリーク (Outfit)`)
};

const zh_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圆滑时尚 (Outfit)`)
};

const ar_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنيق (Outfit)`)
};

const id_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegan (Outfit)`)
};

const it_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegante (Outfit)`)
};

const ru_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Элегантный (Outfit)`)
};

const pt_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegante (Outfit)`)
};

const ko_sleek_outfit = /** @type {(inputs: Sleek_OutfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`슬릭 (Outfit)`)
};

/**
* | output |
* | --- |
* | "Sleek (Outfit)" |
*
* @param {Sleek_OutfitInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sleek_outfit = /** @type {((inputs?: Sleek_OutfitInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sleek_OutfitInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sleek_outfit(inputs)
	if (locale === "es") return es_sleek_outfit(inputs)
	if (locale === "fr") return fr_sleek_outfit(inputs)
	if (locale === "de") return de_sleek_outfit(inputs)
	if (locale === "ja") return ja_sleek_outfit(inputs)
	if (locale === "zh") return zh_sleek_outfit(inputs)
	if (locale === "ar") return ar_sleek_outfit(inputs)
	if (locale === "id") return id_sleek_outfit(inputs)
	if (locale === "it") return it_sleek_outfit(inputs)
	if (locale === "ru") return ru_sleek_outfit(inputs)
	if (locale === "pt") return pt_sleek_outfit(inputs)
	return ko_sleek_outfit(inputs)
});